module.exports = __webpack_public_path__ + "static/media/curve1-bl.30d8269f.svg";